import { addSearchParamsToUrl } from '@fourthwall/utils/dist/links';
export const addProtocol = (url) => {
    return !url.startsWith('https://') ? `https://${url}` : url;
};
export const stripProtocol = (url) => {
    return url.replace(/^https?:\/\//, '');
};
export const addUtmSourceParamToUrl = (url, sourceValue) => addSearchParamsToUrl(url, { utm_source: sourceValue });
